import { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Stack
} from "@mui/material";
import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import logo1 from "../../assets/images/Vector.svg"
import logo2 from "../../assets/images/Vector1.svg"
import logo3 from "../../assets/images/Vector2.svg"
import logo4 from "../../assets/images/Group 579.svg"
import uparrow from "../../assets/arrowicons/Group 26.svg"
import Downarrow from "../../assets/arrowicons/Group 28.svg"

import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";



export default function KpiMetricscards({ cardsData = [], kpiBriefData = [] }) {
  // const [openDetails, setOpenDetails] = useState(false);
  const [openCardIndex, setOpenCardIndex] = useState(null);

  const handleToggleDetails = (index) => {
    setOpenCardIndex(prev => prev === index ? null : index);
  };

  const [showGoal, setShowGoal] = useState(false);
  const [selectedKpiBrief, setSelectedKpiBrief] = useState(null);

  useEffect(() => {
    if (!selectedKpiBrief && kpiBriefData.length > 0) {
      setSelectedKpiBrief(kpiBriefData[0]);
    }
  }, [kpiBriefData, selectedKpiBrief]);
  // console.log(selectedKpiBrief, "****")
  const navigate = useNavigate();

  const color = "#0e5ba0";
  const location = useLocation();
  const handleOpenReport = (title) => {
    if (title === "Net Sales") {
      window.open(
        "https://app.fabric.microsoft.com/groups/430a39ed-cee2-4e8f-a7d9-3656dd3e9c18/reports/9c8a8269-8419-4ce3-9039-2de4e055ee73/d60bec7ea6a63e394c46?experience=fabric-developer", "_blank",
      );
    }
  };
  const titleRef = React.useRef(null);
  const [isOverflow, setIsOverflow] = React.useState(false);
  const [overflowMap, setOverflowMap] = React.useState({});






  return (
    <Grid container rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 1.5, md: 2 }}
      sx={{ mt: 0 }}>
      {cardsData.map((card, i) => (
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={i} sx={{ paddingTop: "26px !important" }}>
          <Card
            sx={{
              borderRadius: "4px",
              background: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
              overflow: "visible",
              position: "relative",
              paddingTop: "28px",
              minWidth: 0  // Allow card to shrink
            }}
          // className="custom-card"
          >
            {/* HEADER LABEL */}
            <Box
              sx={{
                position: "absolute",
                top: "-10px",
                left: { xs: "8px", sm: "12px", md: "16px" },
                right: { xs: "8px", sm: "12px", md: "16px" },
                height: "36px",
                background: "#115f9c",
                borderRadius: "4px !important",
                display: "flex",
                alignItems: "center",
                p: { xs: "0px 8px", sm: "0px 10px", md: "0px 12px" },
                boxShadow: "0px 4px 12px rgba(13,110,253,0.35)"
              }}
            >
              {/*  TITLE + STATUS DOT */}
              <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, overflow: "hidden" }}>
                <Tooltip
                  title={card.title}
                  placement="top"
                  arrow
                  disableHoverListener={!overflowMap[i]}   // only this card
                >
                  <Typography
                    ref={(el) => {
                      if (!el) return;

                      const isOverflowing = el.scrollWidth > el.clientWidth;

                      setOverflowMap(prev => {
                        if (prev[i] === isOverflowing) return prev;
                        return { ...prev, [i]: isOverflowing };
                      });
                    }}
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "11px", sm: "12px", md: "16px" },
                      fontWeight: 200,
                      mr: "6px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",

                      // cursor only when truncated
                      cursor: overflowMap[i] ? "pointer" : "default",
                    }}
                  >
                    {card.title}
                  </Typography>
                </Tooltip>




                <Tooltip
                  title="Calculated from the latest fully closed period; no open-period data included."
                  placement="right"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#1f1f1f",
                        color: "#fff",
                        fontSize: "12px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        maxWidth: "260px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#1f1f1f",
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: card.showIndicator ? 8 : 0,
                      height: card.showIndicator ? 8 : 0,
                      borderRadius: "50%",
                      cursor: "pointer",
                      backgroundColor:
                        card.values.some(v => v.status === "decrease")
                          ? "#d9534f"
                          : card.values.some(v => v.status === "increase")
                            ? "#11C634"
                            : "#cccccc",
                    }}
                  />
                </Tooltip>

              </Box>

              {/* TOGGLE BUTTON */}
              <Box
                onClick={() => handleToggleDetails(i)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: 300,
                  gap: "4px",
                  userSelect: "none"
                }}
              >
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: "18px",
                    color: "#ffffff",
                    transition: "0.3s",
                    transform: openCardIndex === i ? "rotate(180deg)" : "rotate(0deg)"

                  }}
                />
                {openCardIndex === i ? "BRIEF" : "DETAILS"}
              </Box>
            </Box>

            <CardContent sx={{ mt: 0, overflowX: "auto", paddingTop: openCardIndex === i ? "8px" : "" }}>
              {openCardIndex !== i ? (
                /* DETAILS VIEW */
                <Box sx={{ display: "flex", justifyContent: "space-between", minWidth: "fit-content", gap: { xs: '22px', sm: '22px', md: '0px' },width:"90%" }}>
                  {card.values.map((v, idx) => {
                    const numericChange = parseFloat(v.change?.replace("%", ""));
                    const isPositive = !isNaN(numericChange) && numericChange > 0;
                    const isNegative = !isNaN(numericChange) && numericChange < 0;
                    const value = Number(parseFloat(v.change?.replace("%", "") || 0).toFixed(1));
                    const isZero = value === 0;

                    return (
                      <Box key={idx} sx={{ textAlign: "left" }}>
                        {/* LABEL + ARROW + CHANGE */}
                        <Box
                          sx={{
                            display: "flex"
                          }}>
                          <Box
                            sx={{
                              position: "relative",
                              "&::after": {
                                content: '""',
                                position: "absolute",
                                left: "0",
                                right: "0",
                                width: "10px",
                                height: "50px",
                                borderLeft: "0.5px solid #404040",
                                borderBottom: "0.5px solid #404040",
                                borderBottomLeftRadius: "10px"
                              }
                            }}
                          >
                            <Chip
                              label={v.label}
                              size="small"
                              sx={{
                                background:
                                  isPositive
                                    ? " #3087C5"
                                    : isNegative
                                      ? "#FF565C"
                                      : " #3087C5",
                                color: "#fff",
                                fontSize: "8px",
                                fontWeight: 300,
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                borderTopRightRadius: "8px",
                                borderBottomRightRadius: "8px",
                                height: "20px",
                                mr: "2px",
                                '& .MuiChip-label': {
                                  padding: '0px 6px',
                                },
                              }}
                            />
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "15px",
                              fontWeight: 300,
                              color: isZero
                                ? "#8E8E8E" :
                                isPositive
                                  ? "#107D25"
                                  : isNegative
                                    ? "#FF565C"
                                    : "#107D25"
                            }}
                          >
                            {!isZero && (
                              isPositive ? (
                                <img src={uparrow} alt="" width={16} height={18} />
                              ) : (
                                <img src={Downarrow} alt="" width={16} height={18} />
                              )
                            )}

                            {isZero && (
                              <Box
                                sx={{
                                  width: 14,
                                  height: 18,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    backgroundColor: "#8E8E8E",
                                  }}
                                />
                              </Box>
                            )}

                            {`${value.toFixed(1)}%`}
                          </Box>
                        </Box>

                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: "300",
                            color: "#111111 ",
                            paddingLeft: "16px"
                          }}
                        >
                          {v.value}
                        </Typography>
                      </Box>
                    )
                  })}
                </Box>
              ) : (
                /* BRIEF VIEW */
                <Box>
                  <Box
                    sx={{
                      mb: 1,
                      textAlign: "left",
                      display: "flex",
                      gap: 1,

                    }}
                  >
                    {card?.values.map((kpibrief, index) => {

                      const numericChange = parseFloat(kpibrief.change?.replace("%", ""));
                      const isPositive = !isNaN(numericChange) && numericChange > 0;
                      const isNegative = !isNaN(numericChange) && numericChange < 0;

                      const numericChangely = parseFloat(kpibrief.changely?.replace("%", ""));
                      const isPositively = !isNaN(numericChangely) && numericChangely > 0;
                      const isNegatively = !isNaN(numericChangely) && numericChangely < 0;
                      console.log(numericChange, "numericChange ly ")
                      console.log(numericChangely, "numericChangely goal")
                      console.log(isPositively, isNegatively, "positive and Negative")

                      const rawValue = showGoal ? kpibrief.change : kpibrief.changely;
                      const numericValue = parseFloat(rawValue?.replace("%", "") || 0);
                      const isZero = numericValue === 0;
                      const isUp = showGoal ? isPositive : isPositively;
                      const isDown = showGoal ? isNegative : isNegatively;
                      console.log(isZero, "isZero")

                      const pctColor =
                        isPositive
                          ? "#107D25"
                          : isNegative
                            ? "#FF565C"
                            : "#107D25";

                      const pctColorbottom =
                        isPositive
                          ? "3px solid #107D25"
                          : isNegative
                            ? "3px solid #FF565C"
                            : "3px solid #107D25";
                      const pctColorbottomly =
                        isPositively
                          ? "3px solid #107D25"
                          : isNegatively
                            ? "3px solid #FF565C"
                            : "3px solid #107D25";


                      const pctColorly =
                        isPositively
                          ? "#107D25"
                          : isNegatively
                            ? "#FF565C"
                            : "#107D25";
                      const bottomGradient =
                        isPositive
                          ? "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(220,250,236,1) 40%)"
                          : "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,235,238,1) 40%)";


                      return (
                        <Box
                          key={index}
                          onClick={() => setSelectedKpiBrief(kpibrief)}
                          sx={{
                            width: 600,
                            borderRadius: "4px",
                            overflow: "hidden",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            display: "flex",
                            flexDirection: "column",
                            fontFamily: "Inter",
                            borderBottom: isZero
                              ? "3px solid #8E8E8E"
                              : showGoal
                                ? pctColorbottom
                                : pctColorbottomly,


                          }}
                        >
                          {/* top row */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              p: "8px 6px 0px 6px"
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#111111",
                                fontWeight: 300
                              }}
                            >
                              {kpibrief.title}
                            </Typography>

                            <Stack
                              direction="row"
                              spacing={0.2}
                              alignItems="center"
                              sx={{
                                ml: 1,
                                fontSize: "10px",
                                fontWeight: 200,
                                color: isZero
                                  ? "#8E8E8E"                       // zero → grey
                                  : showGoal
                                    ? pctColor
                                    : pctColorly,
                              }}
                            >
                              {/* Icon */}
                              {!isZero && (
                                isUp ? (
                                  <img src={uparrow} alt="" width={16} height={18} />
                                ) : (
                                  <img src={Downarrow} alt="" width={16} height={18} />
                                )
                              )}

                              {/* Dot for 0.0% */}
                              {isZero && (
                                <Box
                                  sx={{
                                    width: 16,
                                    height: 18,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: "50%",
                                      backgroundColor: "#8E8E8E",
                                    }}
                                  />
                                </Box>
                              )}

                              {/* Value */}
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: isZero
                                    ? "#8E8E8E"                    // value grey
                                    : showGoal
                                      ? pctColor
                                      : pctColorly,
                                }}
                              >
                                {`${numericValue.toFixed(1)}%`}
                              </Typography>
                            </Stack>

                          </Box>

                          {/* value + LY */}
                          <Box
                            sx={{
                              p: "12px 10px 8px 0px",
                              background: bottomGradient
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontWeight: '200',
                                lineHeight: 1,
                                textAlign: "center"
                              }}
                            >
                              {kpibrief.value}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                // alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                mt: "14px"
                              }}
                            >
                              <Chip
                                label={showGoal ? "GOAL" : "LY"}
                                size="small"
                                sx={{
                                  bgcolor: isZero ? "#8E8E8E" : (showGoal ? pctColor : pctColorly),
                                  color: "#fff",
                                  height: "18px",
                                  fontWeight: 400,
                                  fontSize: 10,
                                  // width: 50,
                                  borderBottomLeftRadius: 0,
                                  borderTopLeftRadius: 0,
                                  borderBottomRightRadius: "6px",
                                  borderTopRightRadius: "6px"
                                }}
                              />

                              <Typography
                                sx={{
                                  fontSize: "12px !important",
                                  color: "#111111",
                                  fontWeight: 200
                                }}
                              >
                                {showGoal ? kpibrief.glvalue : kpibrief.lyValue}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>

                  {/* QUICK ACTIONS */}
                  <Box
                    sx={{
                      mt: "20px",
                      textAlign: "left",
                      display: "flex",
                      gap: 1
                    }}
                  >
                    <Box
                      sx={{
                        width: 500,
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        pl: 1
                      }}
                    >

                      {/* SHOW GOAL */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => setShowGoal(prev => !prev)}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo4} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          {showGoal ? "SHOW LY" : "SHOW GOAL"}
                        </Typography>
                      </Stack>

                      {/* ASK AGENT */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => {
                          const predefinedMessage = "Create a Line Chart for monthly Sales vs Goal for the Past 12 months";
                          navigate("/intelligence", {
                            state: selectedKpiBrief?.Kpinames === "Net Sales"
                              ? { kpi: selectedKpiBrief, message: predefinedMessage }
                              : { message: predefinedMessage },
                          });
                        }}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo1} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          ASK AGENT (BETA)
                        </Typography>
                      </Stack>

                      {/* OPEN CUBE */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => handleOpenReport(card.title)}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo3} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          OPEN CUBE
                        </Typography>
                      </Stack>

                      {/* MSG ANALYST */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        <img src={logo2} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          MSG ANALYST (BETA)
                        </Typography>
                      </Stack>

                    </Box>
                  </Box>

                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
